module.exports = __webpack_public_path__ + "static/media/breakPedal.1715b1a2.png";